import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getPageTitle } from '@configs/routes';
import { trackPageView } from './analyticsService';

interface UsePageViewOptions {
  userId?: string;
  pageName?: string;
}

/**
 * 페이지 조회를 자동으로 추적하는 훅
 * 라우트 변경 시 자동으로 페이지 조회 이벤트를 전송합니다.
 */
export const usePageView = (options: UsePageViewOptions = {}) => {
  const { pathname } = useLocation();
  const { userId, pageName: customPageName } = options;
  const prevPathRef = useRef<string | null>(null);

  useEffect(() => {
    // 같은 페이지 중복 호출 방지
    if (prevPathRef.current === pathname) {
      return;
    }
    prevPathRef.current = pathname;

    const pageName = customPageName || getPageTitle(pathname) || pathname;

    trackPageView(
      {
        pageUrl: pathname,
        pageName,
        referrer: document.referrer || undefined,
      },
      userId,
    ).catch((error) => {
      console.error('[Analytics] Page view tracking failed:', error);
    });
  }, [pathname, userId, customPageName]);
};
